import React, { useState } from "react";
import withIntl from "../../utils/withIntl";
import { Grid } from "@material-ui/core";
import RepeatSetting from "./RepeatSetting";

function TimestampSetting(props) {
  const [timestamp, setTimestamp] = useState(props.timestamp);

  return (
    <Grid container spacing={1} style={{ border: "1px solid lightgrey" }}>
      <Grid item xs={12}>
        {/*<DateTimePicker*/}
        {/*  value={new Date(timestamp.timestamp * 1000)}*/}
        {/*  onChange={(date) => {*/}
        {/*    let newTimestamp = { ...timestamp };*/}
        {/*    newTimestamp.timestamp = Math.round(date.getTime() / 1000);*/}
        {/*    setTimestamp(newTimestamp);*/}
        {/*    props.onChange(newTimestamp);*/}
        {/*  }}*/}
        {/*/>*/}
      </Grid>
      <RepeatSetting
        repeatedPattern={timestamp}
        onChange={(newR) => {
          setTimestamp(newR);
          props.onChange(newR);
        }}
        onRemove={() => {
          props.onRemove();
        }}
      />
    </Grid>
  );
}

export default withIntl(TimestampSetting);
